import React, { useEffect } from 'react';
import { Container, IconButton, Table, Tag, Loader, Pagination } from 'rsuite';
import CollaspedOutlineIcon from '@rsuite/icons/CollaspedOutline';
import ExpandOutlineIcon from '@rsuite/icons/ExpandOutline';
import { useDispatch, useSelector } from 'react-redux';
import { listAudits } from '../actions/auditActions';

const { Column, HeaderCell, Cell } = Table;

const rowKey = 'id';

const ExpandCell = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
  <Cell {...props} style={{ padding: 5 }}>
    <IconButton
      appearance="subtle"
      onClick={() => {
        onChange(rowData);
      }}
      icon={
        expandedRowKeys.some(key => key === rowData[rowKey]) ? (
          <CollaspedOutlineIcon />
        ) : (
          <ExpandOutlineIcon />
        )
      }
    />
  </Cell>
);

const renderRowExpanded = rowData => {
  return (
    <div style={{paddingLeft: '30px'}}>
      <p>Ver 1: {rowData.email}</p>
      <p>Ver 2: {rowData.phone}</p>
    </div>
  );
};

const AuditTable = () => {
const [sortColumn, setSortColumn] = React.useState();
const [sortType, setSortType] = React.useState();
const [loadingTable, setLoadingTable] = React.useState(false);

const dispatch = useDispatch()
const auditList = useSelector((state) => state.auditList)
const {loading, error, audits} = auditList

useEffect(() => {
  dispatch(listAudits())

  }, [dispatch])

const getData = () => {
    if (sortColumn && sortType) {
      return audits.data.audit_trails.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string') {
          x = x.charCodeAt();
        }
        if (typeof y === 'string') {
          y = y.charCodeAt();
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return audits.data.audit_trails;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoadingTable(true);
    setTimeout(() => {
      setLoadingTable(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 300);
  };

  const [expandedRowKeys, setExpandedRowKeys] = React.useState([]);

  const handleExpanded = (rowData, dataKey) => {
    let open = false;
    const nextExpandedRowKeys = [];

    expandedRowKeys.forEach(key => {
      if (key === rowData[rowKey]) {
        open = true;
      } else {
        nextExpandedRowKeys.push(key);
      }
    });

    if (!open) {
      nextExpandedRowKeys.push(rowData[rowKey]);
    }

    setExpandedRowKeys(nextExpandedRowKeys);
  };

  // Pagination
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };


  return (
    <Container>
        {audits.success ? ( <Table
      shouldUpdateScroll={false} // Prevent the scrollbar from scrolling to the top after the table content area height changes.
      data={getData()}
      rowKey={rowKey}
      expandedRowKeys={expandedRowKeys}
      renderRowExpanded={renderRowExpanded}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={handleSortColumn}
      loading={loadingTable}
      autoHeight={true}
      cellBordered={false}
      virtualized={false}
      bordered
    >
      <Column width={50} align="center">
        <HeaderCell>...</HeaderCell>
        <ExpandCell dataKey="id" expandedRowKeys={expandedRowKeys} onChange={handleExpanded} />
      </Column>

      <Column width={200}>
        <HeaderCell>Document Id</HeaderCell>
        <Cell dataKey="document_number" />
      </Column>
    
      <Column width={200} sortable>
        <HeaderCell>Application Type</HeaderCell>
        <Cell dataKey="agent" />
      </Column>
      <Column width={200} sortable>
        <HeaderCell>Action</HeaderCell>
        <Cell dataKey="action" />
      </Column>

      <Column width={200} sortable>
        <HeaderCell>Status</HeaderCell>
        <Cell dataKey="outcome" />
      </Column>
       <Column width={300}>
        <HeaderCell>Last modified</HeaderCell>
        <Cell dataKey="createdAt" />
      </Column>
    </Table>): (<Loader size="md" backdrop content="loading audits..." vertical ></Loader>)}
          {audits.success ? (<div className='table_pag' style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={getData().length}
          limitOptions={[10, 30, 50]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>): (<Loader/>)}
        
    </Container>
    
  );
};

export default AuditTable